import { render, staticRenderFns } from "./BillingTemplates.vue?vue&type=template&id=f95d7240"
import script from "./BillingTemplates.vue?vue&type=script&lang=js"
export * from "./BillingTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports